/* eslint-disable */
import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import LinearProgress from "@material-ui/core/LinearProgress";
import moment from "moment";
import { FormattedMessage } from "react-intl";
import { SnackBarBulkExport, IDataSource, useBulkExportAPI } from "../shared";
import messages from "../messages";
import { useHookSubscribe } from "../../react-rxjs";

const Message: React.FC<{ measurement?: IDataSource }> = ({ measurement }) => (
  <>
    <FormattedMessage {...messages.snackBarTitle} />
    <span>
      {`${measurement && measurement.name}_${moment(new Date()).format("YYYY.MM.DD")}`}
      <LinearProgress variant="determinate" value={50} />
    </span>
  </>
);

export const SnackBarBulkExportBASF: React.FC = (props) => {
  return <SnackBarBulkExport messageComponent={Message} />;
};
